import React, { useState, useEffect, useRef } from "react";
import moment from "moment"; // Date Formate Library
import axios from "axios";
import $ from "jquery";

import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "../../Pages/SideMenu";
import Header from "../../Pages/Header";
import Footer from "../../Pages/Footer";
import Logout from "../../Pages/Logout";
import UploadFile from "../../images/uploadfile.png";

//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEdit, faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";

//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";

// Date
import "react-datepicker/dist/react-datepicker.css";
import {
  getFileByPath,
  getMasters,
  openStock,
  stockInWardSubmit,
} from "../../Utilities/URLCONSTANTS";
// import { Oval as Loader } from 'react-loader-spinner';
import Loader from "../../Utilities/Loader";
import { GetApiHeaders, GetMediaImageBlobUrl, GetMediaImageUrl, ProtectedImage } from "../../Utilities/NetworkUtilities";
import { filterObjects } from "../../Utils";
//import Loader from '../Utilities/Loader';
import * as XLSX from "xlsx"; // Import XLSX as an object
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from 'react-router-dom';
import MassUpload from "./massUpload";
import { CustomDatePickerInput, customstyles, modalCustomStyles } from "../../Utilities/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Add_Icon from "../../images/Add_Icon.svg";
import searchIcon from "../../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../../Utilities/Pagination";

//UserMaster
const StockInWard = () => {
  const navigate = useNavigate();
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Id, setId] = useState(0);
  const [stockInwardDate, setStockInwardDate] = useState("");
  const [newStockInwardDate, setNewStockInwardDate] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productYear, setProductYear] = useState("");
  const [productCategoryID, setProductCategoryID] = useState("");
  const [productName, setProductName] = useState("");
  // const [productNameID, setProductNameID] = useState(-1);
  const [productNameID, setProductNameID] = useState("");
  const [productMake, setProductMake] = useState("");
  const [productMakeID, setProductMakeID] = useState("");
  const [productInDate, setProductInDate] = useState(null);
  const [stockInQuantity, setStockInQuantity] = useState("");
  const [unitSize_uim, setUnitSize_uim] = useState("");
  const [unitSize_uimID, setUnitSize_uimID] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [productStoreLocation, setProductStoreLocation] = useState("");
  const [productStoreLocationID, setProductStoreLocationID] = useState("");
  // const [productRackLocation, setProductRackLocation] = useState("");
  const [productPONumber, setProductPONumber] = useState("");
  const [productInvoiceNumber, setProductInvoiceNumber] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [vendorName1, setVendorName1] = useState("");
  const [vendorID, setVendorID] = useState("");
  const [batchNumber, setBatchNumber] = useState("");
  const [productManufactureDate, setProductManufactureDate] = useState("");
  const [newProductManufactureDate, setNewProductManufactureDate] =
    useState("");
  const [productExpiryDate, setProductExpiryDate] = useState("");
  const [newProductExpiryDate, setNewProductExpiryDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [submittedDate, setSubmittedDate] = useState("");
  const [newSubmittedDate, setNewSubmittedDate] = useState("");
  const [imageUpload, setImageUpload] = useState(null);
  const [imageUploadShow, setImageUploadShow] = useState(null);
  const [status, setStatus] = useState("");
  const [data, setData] = useState([]);
  //const [format, setFormat] = useState("");
  const [recordExists, setRecordExists] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [getMasterVendor, setGetMasterVendor] = useState([]);
  const [dcOrInvoice, setDcOrInvoice] = useState("");

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [buttonText, setButtonText] = useState("Submit");
  const [showPopup, setShowPopup] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [showWarningPopup, setShowWarningPopup] = useState(false);

  //Errors
  const [errorSubmittedDate, setErrorSubmittedDate] = useState("");
  const [errorProductInDate, setErrorProductInDate] = useState("");
  const [errorProductCategory, setErrorProductCategory] = useState("");
  const [errorProductName, setErrorProductName] = useState("");
  const [errorProductMake, setErrorProductMake] = useState("");
  const [errorStockInQuantity, setErrorStockInQuantity] = useState("");
  const [errorUnitSize, setErrorUnitSize] = useState("");
  const [errorUnitPrice, setErrorUnitPrice] = useState("");
  const [errorInvoiceDc, setErrorInvoiceDc] = useState("");
  const [errorProductStoreLocation, setErrorProductStoreLocation] =
    useState("");
  // const [errorProductRackLocation, setErrorProductRackLocation] = useState("");
  const [errorProductPONumber, setErrorProductPONumber] = useState("");
  const [errorProductInvoiceNumber, setErrorProductInvoiceNumber] =
    useState("");
  const [productInvoiceOrDCno, setProductInvoiceOrDCno] = useState();
  const [errorVendorName, setErrorVendorName] = useState("");
  const [errorBatchNumber, setErrorBatchNumber] = useState("");
  const [errorProductManufactureDate, setErrorProductManufactureDate] =
    useState("");
  const [errorProductExpiryDate, setErrorProductExpiryDate] = useState("");
  const [errorRemarks, setErrorRemarks] = useState("");
  // const [base64Image, setBase64Image] = useState(null);
  const [errorImageUpload, setErrorImageUpload] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [brandOptions, setBrandOptions] = useState([]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);

  //Product Years
  const [productYearBaseOptions, setProductYearBaseOptions] = useState([])
  const [selectedYear, setSelectedYear] = useState(""); // Store selected year
  const [errorProductYearBase, setErrorProductYearBase] = useState("");


  const [unitSizeOptions, setUnitSizeOptions] = useState([]);
  const [productNameOptions, setProductNameOptions] = useState([]);
  const [productNameOptionsOriginal, setProductNameOptionsOriginal] = useState(
    []
  );
  const [storeLocationOptions, setStoreLocationOptions] = useState([]);

  const [loaderImage, setLoaderImage] = useState(
    require("../../images/cs_loader.gif")
  );
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  // const totalItems = filteredData.length;
  // In your handleFilter function, update filteredData based on searchTerm

  const [selectedOption, setSelectedOption] = useState("invoice"); // Initialize with 'invoice' as the default option
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [dcNumber, setDcNumber] = useState("");
  const [profileImages, setProfileImages] = useState({});


  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data) {
      const search = searchTerm.toLowerCase();
      const filteredResults = data.filter(
        (item) =>
          (item.productInDate || "").toLowerCase().includes(search) ||
          (item.productManufactureDate || "").toLowerCase().includes(search) ||
          (item.productExpiryDate || "").toLowerCase().includes(search) ||
          (item.submittedDate || "").toLowerCase().includes(search) ||
          (item.productCategory || "").toLowerCase().includes(search) ||
          (item.productYear || "").toLowerCase().includes(search) ||
          (item.productName || "").toLowerCase().includes(search) ||
          (item.productMake || "").toLowerCase().includes(search) ||
          (item.inWardStock?.toString() || "").toLowerCase().includes(search) ||
          (item.unitSize_uim || "").toLowerCase().includes(search) ||
          (item.productStoreLocation || "").toLowerCase().includes(search) ||
          (item.productPONumber || "").toLowerCase().includes(search) ||
          (item.productInvoiceNumber || "").toLowerCase().includes(search) ||
          (item.vendorName || "").toLowerCase().includes(search) ||
          (item.batchNumber || "").toLowerCase().includes(search)
      );

      setFilteredData(filteredResults);
      handlePageClick(1);
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  // const totalItems = data.length;

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };


  const exportToExcel = (item) => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);

      if (isNaN(date)) {
        return ''; // Return empty string for invalid dates
      }

      const day = ('0' + date.getDate()).slice(-2);
      const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    };

    const data = [
      [
        "S.No",
        "Stock In - Ward Date",
        "Product Category",
        "Product Year",
        "Product Name",
        "Product Make(Brand)",
        "In-Ward Stock(Stock In Quantity)",
        "Unit Size(UIM)",
        "Unit Price",
        "	Product Store Location",
        "Product PO Number",
        "Invoice / DC",
        "Product Invoice/DC Number",
        "Vendor Name",
        "Batch Number",
        "Product Manufacture Date",
        "Product Expiry Date",
        "Submitted Date & Time",
        "Uploaded Image",
        "Remarks",
      ],
      // ...currentItems.map((item) => [
      ...filteredData.map((item, index) => [
        index + 1,
        formatDate(item.productInDate),
        item.productCategory,
        item.productYear,
        item.productName,
        item.productMake,
        item.inWardStock,
        item.unitSize_uim,
        item.unitPrice,
        item.productStoreLocation,
        item.productInvoiceNumber,
        item.productInvoiceOrDC,
        item.productPONumber,
        item.vendorName,
        item.batchNumber,
        formatDate(item.productManufactureDate),
        formatDate(item.productExpiryDate),
        formatDate(item.submittedDate),
        item.imageUpload,
        item.remarks,
        // item.status === "1" ? "Active" : "InActive",
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Save the file
    XLSX.writeFile(wb, "StockInWard.xlsx");
  };

  useEffect(() => {
    console.log("datahghghg", JSON.stringify(data));
  }, [data]);

  // validations

  const handleFileChange = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      const reader = new FileReader();

      reader.onload = () => {
        const dataURL = reader.result;
        const base64 = dataURL.split(",")[1];
        //setprofilePicUrl(base64);
        setImageUpload(base64);
        setImageUploadShow(dataURL);
        // setErrorImageUpload("");
      };

      reader.onerror = () => {
        setErrorImageUpload("Error reading the selected image.");
      };

      reader.readAsDataURL(selectedImage);
    }
  };


  const handleProductCategory = async (event) => {
    const selectedCategory = event.target.value;
    const selectedCategoryId = event.target.options[event.target.selectedIndex].getAttribute("code");
    setProductCategory(selectedCategory);
    setProductCategoryID(selectedCategoryId);
    console.log("Selected Category:", selectedCategoryId);
    // Filter products by category
    let filteredByCategory = productNameOptionsOriginal.filter(

      (product) => product.productCategoryId.toString() === selectedCategoryId.toString()
    );
    console.log("Products filtered by category:", filteredByCategory);
    // If year is already selected, apply year filter too
    if (selectedYear) {
      filteredByCategory = filteredByCategory.filter(
        (product) => product.year === selectedYear
      );
      console.log("Filtered by Category and Year:", filteredByCategory);
    }

    setProductNameOptions(filteredByCategory);
    if (selectedCategory) {
      setErrorProductCategory("");
    }
  };

  const handleProductYearChange = (e) => {
    const selectedYearValue = e.target.value;
    setSelectedYear(selectedYearValue);
    setErrorProductYearBase("");

    console.log("Selected Year:", selectedYearValue);

    // Filter products by selected year
    const filteredByYear = productNameOptionsOriginal.filter(
      (product) => product.year === selectedYearValue
    );

    console.log("Products filtered by year:", filteredByYear);

    console.log("productCategoryID:", productCategoryID);
    // If category is already selected, apply category filter too
    if (productCategoryID) {
      const filteredByYearAndCategory = filteredByYear.filter(
        (product) => product.productCategoryId.toString() === productCategoryID.toString()
      );
      setProductNameOptions(filteredByYearAndCategory);
      console.log("Filtered by Year and Category:", filteredByYearAndCategory);
    } else {
      setProductNameOptions(filteredByYear);
    }
  };



  const handleProductName = (event) => {
    const selectedValue = event.target.value;
    const selectedId = event.target.options[event.target.selectedIndex].getAttribute("code");
    const selectedBrand = event.target.options[event.target.selectedIndex].getAttribute("data-productMake");
    const selectedUIM = event.target.options[event.target.selectedIndex].getAttribute("data-uim");
    const selectedUnitCost = event.target.options[event.target.selectedIndex].getAttribute("data-unitCost");
    const selectedProductMakeId = event.target.options[event.target.selectedIndex].getAttribute("data-productbrandId");

    setProductMake(selectedBrand)
    setUnitSize_uim(selectedUIM)
    setUnitPrice(selectedUnitCost)
    setProductMakeID(selectedProductMakeId)

    if (selectedValue) {
      setProductName(selectedValue);
      setProductNameID(selectedId);
      setErrorProductName("");
    } else {
      setErrorProductName("Product name cannot exceed 255 characters.");
    }
    // Clear productMake error if a valid value is set
    if (selectedBrand && selectedBrand.trim() !== "") {
      setErrorProductMake(""); // Clear the product make error
    }
    if (selectedUIM && selectedUIM.trim() !== "") {
      setErrorUnitSize(""); // Clear the unit size error
    }
    if (String(selectedUnitCost).trim() !== "") {
      setErrorUnitPrice("");
    }
  };


  console.log(productMake, "Product Make")
  const handleProductBrand = (event) => {
    const selectedMake = event.target.value;
    const selectedMakeId =
      event.target.options[event.target.selectedIndex].getAttribute("code");
    console.log("Brand", selectedMake + "--" + selectedMakeId);
    setProductMake(selectedMake);
    setProductMakeID(selectedMakeId);
    if (selectedMake) {
      setErrorProductMake("");
    }
  };

  const handleProductInDate = (event) => {
    var date = event;
    if (!moment.isMoment(date)) {
      date = moment(date); // Convert to moment object if not already
    }
    const newDob = event.target.value; //alert(newDob);
    //alert(newDob);
    if (date.isValid()) {
      const today = moment();
      const minDate = moment().subtract(30, "days");
      if (date.isBefore(minDate)) {
        setErrorProductInDate(
          "Date should not be more than 30 days in the past."
        );
        return;
      } else if (date.isAfter(today)) {
        setErrorProductInDate("Date should not be in the future.");
        return;
      }
      setErrorProductInDate("");
      setProductInDate(date);
      const selectedDateObj = new Date(newDob);
      const yyyy = selectedDateObj.getFullYear();
      let mm = selectedDateObj.getMonth() + 1; // Months start at 0!
      let dd = selectedDateObj.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      //setDob(newDob);
      setStockInwardDate(yyyy + "-" + mm + "-" + dd);
      setNewStockInwardDate(dd + "-" + mm + "-" + yyyy);
      const formattedProductInDate = date.format("YYYY-MM-DD HH:mm:ss.SSS");
      console.log("Formatted ProductInDate:", formattedProductInDate);
    } else {
      setErrorProductInDate("Invalid date.");
      setProductInDate(null);
    }
    if (productInDate && productInDate.isValid()) {
      setErrorProductInDate("");
    }
  };

  const handleSubmittedDate = (e) => {
    setSubmittedDate(e.target.value);
    const selectedDateObj = new Date(e.target.value);
    // Format the date as DD-MM-YYYY
    const yyyy = selectedDateObj.getFullYear();
    let mm = selectedDateObj.getMonth() + 1; // Months start at 0!
    let dd = selectedDateObj.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    setNewSubmittedDate(dd + "-" + mm + "-" + yyyy);
    if (e.target.value) {
      setErrorSubmittedDate("");
      const formattedSubmittedDate = moment(submittedDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      console.log("Formatted Submitted Date:", formattedSubmittedDate);
    }
  };


  const handleStockInQuantity = (e) => {
    const input = e.target.value;

    // Handle empty input
    if (input === "") {
      setStockInQuantity("");
      setErrorStockInQuantity("");
      return;
    }

    // Prevent negative values
    if (input.startsWith("-")) {
      setErrorStockInQuantity("Negative values are not allowed.");
      return;
    }

    // Check if the input is a valid number with up to 5 digits
    if (/^[0-9]{1,5}$/.test(input)) {
      const Quantity = parseInt(input, 10); // Convert the input string to an integer
      if (Quantity >= 1 && Quantity <= 99999) {
        // If the input is within the valid range
        setStockInQuantity(Quantity);
        setErrorStockInQuantity("");
      } else {
        setErrorStockInQuantity("Please enter a number between 1 and 99999.");
      }
    } else {
      setErrorStockInQuantity("Should accept up to 5 digits only.");
    }
  };

  const handleUnitSize = (event) => {
    const selectedSize = event.target.value;
    const selectedSizeId =
      event.target.options[event.target.selectedIndex].getAttribute("code");
    console.log("UnitSize", selectedSize + "--" + selectedSizeId);
    setUnitSize_uim(event.target.value);
    setUnitSize_uimID(event.target.value);
    if (selectedSize) {
      setUnitSize_uim(selectedSize);
      setErrorUnitSize("");
    }
  };


  const handleUnitPrice = (e) => {
    const input = e.target.value;
    if (input === "") {
      setUnitPrice("");
      setErrorUnitPrice("");
      return;
    }
    if (input.startsWith("-")) {
      setErrorUnitPrice("Negative values are not allowed.");
      return;
    }
    if (/^\d{1,5}(\.\d*)?$/.test(input)) {
      const inputValue = parseFloat(input);
      if (inputValue >= 1 && inputValue <= 99999) {
        setUnitPrice(input);
        setErrorUnitPrice("");
      } else {
        setErrorUnitPrice("Please enter a number between 1 and 99999.");
      }
    } else {
      setErrorUnitPrice("The input should have up to 5 digits before the decimal.");
    }
  };


  const handleProductStoreLocation = (event) => {
    const selectedStoreLocation = event.target.value;
    const selectedStoreLocationId =
      event.target.options[event.target.selectedIndex].getAttribute("code");
    console.log(
      "Location",
      selectedStoreLocation + "--" + selectedStoreLocationId
    );
    setProductStoreLocation(selectedStoreLocation);
    setProductStoreLocationID(selectedStoreLocationId);
    if (selectedStoreLocation) {
      setErrorProductStoreLocation("");
    }
  };

  const handleProductPoNumber = (e) => {
    const input = e.target.value;
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    setProductPONumber(input);
    if (input.length > 0) {
      if (input.length < 8 || input.length > 64) {
        setErrorProductPONumber(
          "Product po number should be min 8 charcaters."
        );
      } else if (!alphanumericRegex.test(input)) {
        setErrorProductPONumber("Please enter only alphanumeric characters.");
      } else {
        setErrorProductPONumber("");
      }
    } else {
      setErrorProductPONumber("Product PO Number is required.");
    }
  };

  // productInvoiceNumber
  const handleProductInvoiceNumber = (e) => {
    const invoice = e.target.value;
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    setProductInvoiceNumber(invoice);
    if (invoice.length > 0) {
      if (invoice.length < 8 || invoice.length > 64) {
        setErrorProductInvoiceNumber("Enter valid Product Invoice No / DC No.");
      } else if (!alphanumericRegex.test(invoice)) {
        setErrorProductInvoiceNumber(
          "Please enter only alphanumeric characters."
        );
      } else {
        setErrorProductInvoiceNumber("");
      }
    } else {
      setErrorProductInvoiceNumber("Product Invoice Number is required.");
    }
  };



  const handleVendor = (e) => {
    const selectedVendor = e.target.value;
    const selectedVendorId =
      e.target.options[e.target.selectedIndex].getAttribute("code");
    console.log("Location", selectedVendor + "--" + selectedVendorId);
    setVendorName(selectedVendor);
    setVendorID(selectedVendorId);
    if (selectedVendor) {
      setErrorVendorName("");
    }
  };

  const getMasterData = async () => {
    const getData = getMasters;
    const headers = await GetApiHeaders();

    try {
      const responseGetData = await axios.post(getData, null, { headers });
      console.log("getmaster Data,", responseGetData);
      setGetMasterVendor(responseGetData.data.response.vendor);
    } catch (err) {
      console.log("getError", err);
    }
  };

  //batchNumber
  const handleBatchNumber = (e) => {
    const batchNumber = e.target.value;
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    setBatchNumber(batchNumber);
    if (batchNumber.length < 8 || batchNumber.length > 64) {
      setErrorBatchNumber("Batch Number must be between 8 and 64 characters.");
    } else if (!alphanumericRegex.test(batchNumber)) {
      setErrorBatchNumber("Please enter only alphanumeric characters.");
    } else {
      setErrorBatchNumber("");
    }
  };

  const handleImageClick = async (request) => {
    if (!request?.imagePath) {
      console.error("Image path is missing");
      return;
    }
    try {
      let blobUrl = "";
      // Complete Media API URL
      if (request.imagePath.startsWith("https")) {
        blobUrl = await GetMediaImageBlobUrl(request.imagePath);
      }
      // Only image path
      else {
        blobUrl = await GetMediaImageUrl(
          getFileByPath,
          request.imagePath
        );
      }

      if (!blobUrl) {
        console.error("Unable to load image");
        return;
      }
      const newWindow = window.open("", "_blank");
      if (!newWindow) {
        console.error("Popup blocked by browser");
        URL.revokeObjectURL(blobUrl);
        return;
      }
      newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Image</title>
              <style>
                html, body {
                  margin: 0;
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: #f5f5f5;
                }
    
                img {
                  max-width: 90%;
                  max-height: 90%;
                  object-fit: contain;
                }
              </style>
            </head>
    
            <body>
              <img src="${blobUrl}" alt="Image" />
            </body>
          </html>
        `);

      newWindow.document.close();

    } catch (error) {
      console.error("Image loading failed:", error);
    }
  };

  //productManufactureDate
  const handleProductManufactureDate = (e) => {
    const Manufacture = e.target.value; //alert(Manufacture);
    setProductManufactureDate(Manufacture);
    const selectedDateObj = new Date(Manufacture);
    const yyyy = selectedDateObj.getFullYear();
    let mm = selectedDateObj.getMonth() + 1; // Months start at 0!
    let dd = selectedDateObj.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    setNewProductManufactureDate(dd + "-" + mm + "-" + yyyy);
    if (Manufacture) {
      setErrorProductManufactureDate("");
      // Format the date using Moment.js
      const formattedDate = moment(productManufactureDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      console.log("Formatted Date:", formattedDate);
    }
  };
  //productExpiryDate
  // const moment = require('moment'); // Import Moment.js library

  const handleProductExpiryDate = (e) => {
    const Expiry = e.target.value;

    // If a valid date is selected
    if (Expiry.length > 0) {
      const formattedExpiryDate = moment(Expiry).format("YYYY-MM-DD"); // Ensure only date (no time)

      // Check if the expiry date is before the manufacture date
      if (moment(Expiry).isBefore(productManufactureDate)) {
        setErrorProductExpiryDate(
          "Expiry date cannot be earlier than manufacturing date."
        );
      } else {
        setProductExpiryDate(formattedExpiryDate); // Store the formatted expiry date

        // Format the date for display (DD-MM-YYYY)
        const selectedDateObj = new Date(Expiry);
        let mm = selectedDateObj.getMonth() + 1; // Months start at 0!
        let dd = selectedDateObj.getDate();
        const yyyy = selectedDateObj.getFullYear();

        if (dd < 10) dd = "0" + dd;
        if (mm < 10) mm = "0" + mm;
        setNewProductExpiryDate(dd + "-" + mm + "-" + yyyy); // Display format as DD-MM-YYYY

        setErrorProductExpiryDate(""); // Clear error message
        console.log("Formatted Expiry Date:", formattedExpiryDate);
      }
    } else {
      setProductExpiryDate("");
      setErrorProductExpiryDate("");
    }
  };

  //Remarks
  // const handleRemarks = (e) => {
  //   const inputRemarks = e.target.value;
  //   if (inputRemarks.length > 255) {
  //     setErrorRemarks("Remarks cannot exceed 255 characters.");
  //     return;
  //   } else {
  //     setErrorRemarks("");
  //   }
  //   setRemarks(inputRemarks);
  // };

  const handleRemarks = (e) => {
    const inputRemarks = e.target.value;
    if (inputRemarks.length > 255) {
      setErrorRemarks("Remarks cannot exceed 255 characters.");
      return;
    } else {
      setErrorRemarks("");
    }
    const formattedInput = inputRemarks.replace(
      /\b[a-z]/g,
      (char) => char.toUpperCase()
    );
    setRemarks(formattedInput);
  };



  const handleSubmit = () => {
    //alert('submitted')
    if (productInDate === "") {
      setErrorProductInDate("Please Enter a product-In-Date");
    }
    if (productCategory === "") {
      setErrorProductCategory("Please Select Product-Category");
    }

    if (selectedYear === "") {
      setErrorProductYearBase("Please Select Product-Year");
    }

    if (productName === "") {
      setErrorProductName("Please Select  ProductName");
    }
    if (productMake === "") {
      setErrorProductMake("Please Select  ProductBrand");
    }
    if (stockInQuantity === "") {
      setErrorStockInQuantity("Please Enter a StockInQuantity");
    }
    if (unitSize_uim === "") {
      setErrorUnitSize("Please Select UnitSize");
    }
    if (unitPrice === "") {
      setErrorUnitPrice("Please Enter a UnitPrice");
    }
    if (productStoreLocation === "") {
      setErrorProductStoreLocation("Please Select  Product Store Location");
    }
    if (productInvoiceOrDCno === "") {
      setErrorInvoiceDc("Please Enter Invoice or Dc No");
    }

    if (productPONumber === "") {
      setErrorProductPONumber("Please Enter a Product PO Number");
    }
    if (productInvoiceNumber === "") {
      setErrorProductInvoiceNumber("Please select Invoice Number or Dc No");
    }
    if (vendorName === "") {
      setErrorVendorName("Please select VendorName");
    }
    if (batchNumber === "") {
      setErrorBatchNumber("Please Enter a BatchNumber");
    }
    if (productManufactureDate === "") {
      setErrorProductManufactureDate("Please Select Product Manufacture Date");
    }
    if (productExpiryDate === "") {
      setErrorProductExpiryDate("Please Select Product Expiry Date");
    }
    if (submittedDate === "") {
      setErrorSubmittedDate("Please Enter a SubmittedDate");
    }

    // if (imageUpload === "") {
    //   setErrorImageUpload("Upload Image");
    // }
    if (remarks === "") {
      setErrorRemarks("Please Enter a Remarks");
    }
    if (status === "") {
      setErrorStatus("Please Enter a Status");
    }

    if (recordExists) {
      setRecordExists("Record already exists.");
      return; // Stop further processing if the record exists
    }

    if (productInDate != "" && productInvoiceNumber != "") {
      if (Id == 0) {
        setIsSubmitted(true);
        handlePostData();
        setErrorProductInDate("");
        setErrorProductCategory("");
        setErrorProductYearBase("");
        setErrorProductName("");
        setErrorProductExpiryDate("");
        setErrorProductManufactureDate("");
        setErrorBatchNumber("");
        setErrorVendorName("");
        setErrorProductInvoiceNumber("");
        setErrorProductPONumber("");
        setErrorProductStoreLocation("");
        setErrorUnitPrice("");
        setErrorUnitSize("");
        setErrorStockInQuantity("");
        setErrorProductMake("");
        setErrorSubmittedDate("");
        // setErrorImageUpload("");
        setErrorRemarks("");
        setErrorStatus("");
      } else {
        //  alert("update"+Id)
        setIsSubmitted(false);
        handlePostData();
        setIsUpdated(true);
      }
    }
  };

  useEffect(() => {
    fetchData();
    getMasterData();
  }, []);

  const fetchData = async () => {
    const apiUrl = openStock;
    const headers = await GetApiHeaders();
    console.log("request with api call", apiUrl);
    setIsLoading(true);
    setTimeout(() => {
      axios
        .get(apiUrl, { headers })
        .then((response) => {
          console.log("response", response);
          setData(response.data.response.openStock);
          setIsLoading(false);
          // setLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        });
    }, 900);
  };
  useEffect(() => {
    getmasters();
  }, []);
  const getmasters = async () => {
    const apiUrl = getMasters;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    axios
      .post(apiUrl, null, { headers })
      .then((response) => {
        setIsLoading(false);
        console.log("responseMake", response);
        setBrandOptions(response.data.response.productBrand);
        setProductCategoryOptions(response.data.response.productCategoryMaster);
        setProductYearBaseOptions(response.data.response.productYears);
        setUnitSizeOptions(response.data.response.uim);
        setProductNameOptionsOriginal(response.data.response.productsMaster);
        setStoreLocationOptions(response.data.response.stockInwardLocations);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const handlePostData = async () => {
    const apiUrl = stockInWardSubmit;
    const headers = await GetApiHeaders();
    const postData = {
      productInDate: stockInwardDate + " 11:59:30.503", //"2023-09-01 11:59:30.503",//newStockInwardDate, // 2023-06-29 11:59:30.503,
      productCategoryID: parseInt(productCategoryID),
      productCategory: productCategory,
      productNameID: parseInt(productNameID),
      productName: productName,
      year: selectedYear,
      productMakeID: parseInt(productMakeID),
      productMake: productMake,
      stockInQuantity: stockInQuantity,
      unitSize_uim: unitSize_uim,
      unitPrice: unitPrice,
      productStoreLocationID: parseInt(productStoreLocationID),
      productStoreLocation: productStoreLocation,
      productInvoiceOrDC: productInvoiceOrDCno,
      productPONumber: productPONumber,
      productInvoiceNumber: productInvoiceNumber,
      vendorName: vendorName,
      vendorID: parseInt(vendorID),
      batchNumber: batchNumber,
      remarks: remarks,
      productManufactureDate: productManufactureDate + " 11:59:30.503",
      productExpiryDate: productExpiryDate + " 11:59:30.503",
      submittedDate: submittedDate + " 11:59:30.503",
      imageUpload: imageUpload,
    };

    console.log("request with api call", apiUrl);

    console.log("request with api call", JSON.stringify(postData));
    setIsLoading(true);

    axios
      .post(apiUrl, postData, { headers })
      .then((response) => {
        setsubmitResponse(response.data.message);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);
        console.log("submit Response:", response);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  };

  const tableRef = useRef(null);
  useEffect(() => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }

    $(tableRef.current).DataTable({
      ordering: false,
    });
  }, []);

  ///modal popup
  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    // setStockInwardDate("");
    setProductInDate("");
    setProductCategory("");
    setProductYear("");
    setProductName("");
    setProductMake("");
    setStockInQuantity("");
    setUnitSize_uim("");
    setUnitPrice("");
    setProductStoreLocation("");
    setProductPONumber("");
    setProductInvoiceNumber("");
    setVendorName("");
    setBatchNumber("");
    setProductManufactureDate("");
    setProductExpiryDate("");
    setRemarks("");
    setStatus("");
    setSubmittedDate("");
    setImageUpload("");
    // setId(0);
  };

  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };

  const handleCancel = () => {
    setShowModal(true);
    setShowPopup(false);
    setShowWarningPopup(false);
    setShowMsg(true);
  };

  const handleCancel_new = () => {
    // alert("handleCancel");
    setShowModal(true);
    setShowPopup(true);
  };

  const closeWarning = () => {
    setShowWarningPopup(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    window.location.reload();
  };


  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };


  const handleRadioChange = (value) => {
    setProductInvoiceOrDCno(value);
    if (value) {
      setErrorProductInvoiceNumber("");
    }
  };

  const handleDownload = () => {
    const data = [
      { sno: '', product: '', name: '' },
    ];
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Stock In Ward.xlsx');
  };


  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      // Check if values are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }
      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  const handleUploadClick = () => {
    navigate("/massUpload");
  };


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    {/* <h5 className="Roles_text">Stock In - Ward</h5> */}
                    <div className="d-flex justify-content-between">
                      <div>
                        <h5 className="mb-0 Sub_role_text">
                          Stock In - Ward
                        </h5>
                      </div>
                      <span
                        className="d-inline-block"
                        tabIndex="0"
                        data-toggle="tooltip"
                        title="Add Stock In Ward"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleUploadClick}

                        >
                          <FontAwesomeIcon
                            icon={faUpload}
                            className="mr-2"
                          />
                          Upload
                        </Button>
                        &nbsp;
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />
                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />
                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div
                          className="card-body"
                          style={{ overflowX: "auto" }}
                        >
                          <Table className="table table-bordered Content_data_table table-striped">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productInDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Stock In - Ward Date
                                    {renderSortIcon("productInDate")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productCategory")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Category
                                    {renderSortIcon("productCategory")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productYear")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Year
                                    {renderSortIcon("productYear")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Name
                                    {renderSortIcon("productName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productMake")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Make(Brand)
                                    {renderSortIcon("productMake")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("inWardStock")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    In-Ward Stock(Stock In Quantity)
                                    {renderSortIcon("inWardStock")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("unitSize_uim")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Unit Size(UIM)
                                    {renderSortIcon("unitSize_uim")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("unitPrice")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Unit Price
                                    {renderSortIcon("unitPrice")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productStoreLocation")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Store Location
                                    {renderSortIcon("productStoreLocation")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productInvoiceNumber")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Invoice/DC Number
                                    {/* Product PO Number */}
                                    {renderSortIcon("productInvoiceNumber")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productInvoiceOrDC")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Invoice / DC
                                    {renderSortIcon("productInvoiceOrDC")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productPONumber")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product PO Number
                                    {/* Product Invoice/DC Number */}
                                    {renderSortIcon("productPONumber")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("vendorName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Vendor Name
                                    {renderSortIcon("vendorName")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("batchNumber")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Batch Number
                                    {renderSortIcon("batchNumber")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productManufactureDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Manufacture Date
                                    {renderSortIcon("productManufactureDate")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productExpiryDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Product Expiry Date
                                    {renderSortIcon("productExpiryDate")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("submittedDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Submitted Date & Time
                                    {renderSortIcon("submittedDate")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("imageUpload")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Uploaded Image
                                    {renderSortIcon("imageUpload")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("remarks")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Remarks
                                    {renderSortIcon("remarks")}
                                  </span>
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {currentItems.length === 0 ? ( // Check if no data is found
                                <Tr>
                                  <Td
                                    colSpan={20}
                                    className="text-center"
                                    style={{ padding: 195, fontSize: 18 }}
                                  >
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                currentItems.map((item, index) => {
                                  var newDateFormat = moment(item.productInDate).format("DD-MMM-YYYY ");
                                  var manufactureDate = moment(item.productManufactureDate);
                                  if (manufactureDate.isValid()) {
                                    manufactureDate = manufactureDate.format("DD-MMM-YYYY ")
                                  } else {
                                    manufactureDate = ""
                                  }
                                  var expiryDate = moment(item.productExpiryDate);
                                  if (expiryDate.isValid()) {
                                    expiryDate = expiryDate.format("DD-MMM-YYYY ")
                                  } else {
                                    expiryDate = ""
                                  }
                                  var sumiteDate = moment(item.submittedDate).format("DD-MMM-YYYY hh:mm:ss A");
                                  return (
                                    <Tr key={index}>
                                      <Td>{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                      <Td>{newDateFormat}</Td>
                                      <Td>{item.productCategory}</Td>
                                      <Td className="text-left">
                                        {item.productYear}
                                      </Td>
                                      <Td className="text-left">
                                        {item.productName}
                                      </Td>
                                      <Td>{item.productMake}</Td>
                                      <Td className="text-center">
                                        {item.inWardStock}
                                      </Td>
                                      <Td className="text-center">
                                        {item.unitSize_uim}
                                      </Td>
                                      <Td className="text-center">
                                        {item.unitPrice}
                                      </Td>
                                      <Td>{item.productStoreLocation}</Td>
                                      <Td className="text-end">
                                        {item.productInvoiceNumber}
                                      </Td>
                                      <Td className="text-end">
                                        {item.productInvoiceOrDC}
                                      </Td>
                                      <Td className="text-right">
                                        {item.productPONumber}
                                      </Td>
                                      <Td className="text-left">
                                        {item.vendorName}
                                      </Td>
                                      <Td className="text-right">
                                        {item.batchNumber}
                                      </Td>
                                      <Td>{manufactureDate}</Td>
                                      <Td>{expiryDate}</Td>
                                      <Td>{sumiteDate}</Td>
                                      {/* <Td>
                                        <img
                                          src={item.imageUpload}
                                          style={{
                                            width: "30px",
                                            height: "40px",
                                            cursor: "pointer",
                                            border: "1px solid black",
                                          }}
                                          onClick={() =>
                                            handleImageClick(item.imageUpload)
                                          }
                                        />
                                      </Td> */}
                                      <Td>
                                        {item.imageUpload && (
                                          <span className="image-gap">
                                            <ProtectedImage
                                              imagePath={item.imageUpload}
                                              onClick={() =>
                                                handleImageClick({
                                                  imagePath: item.imageUpload,
                                                })
                                              }
                                            />
                                          </span>
                                        )}
                                      </Td>

                                      <Td className="text-left">
                                        {item.remarks}
                                      </Td>
                                    </Tr>
                                  );
                                })
                              )}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                        </div>
                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body
                              className="pl-md-5 pr-md-5 pt-0"
                              style={{ overflowY: "auto", maxHeight: "85vh" }}
                            >
                              <div className="d-flex justify-content-center mb-3 font-weight-600 ">
                                <span className="modal_title">
                                  Stock In Ward
                                </span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="InputDate"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Stock In - Ward Date
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group w-100">
                                    <DatePicker
                                      selected={stockInwardDate ? new Date(stockInwardDate) : null}
                                      onChange={(date) =>
                                        handleProductInDate({
                                          target: {
                                            value: date
                                              ? moment(date).format("YYYY-MM-DD")
                                              : "",
                                          },
                                        })
                                      }
                                      dateFormat="dd-MMM-yyyy"
                                      placeholderText="Stock In - Ward Date"
                                      maxDate={new Date()}
                                      minDate={moment().subtract(30, "days").toDate()}
                                      customInput={<CustomDatePickerInput />}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorProductInDate}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="productCategory"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Category
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={productCategoryOptions.map((item) => ({
                                        value: item.name,
                                        label: item.name,
                                        code: item.code,
                                      }))}
                                      value={
                                        productCategory
                                          ? {
                                            value: productCategory,
                                            label: productCategory,
                                          }
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleProductCategory({
                                          target: {
                                            value: selectedOption?.value || "",
                                            selectedIndex: 0,
                                            options: [
                                              {
                                                getAttribute: (attr) =>
                                                  attr === "code"
                                                    ? selectedOption?.code || ""
                                                    : null,
                                              },
                                            ],
                                          },
                                        })
                                      }
                                      placeholder="Select Product Category"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorProductCategory}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="productYear"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Year
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={productYearBaseOptions.map((item) => ({
                                        value: String(item.name),
                                        label: item.name,
                                      }))}
                                      value={
                                        selectedYear
                                          ? productYearBaseOptions
                                            .map((item) => ({
                                              value: String(item.name),
                                              label: item.name,
                                            }))
                                            .find(
                                              (option) =>
                                                option.value === String(selectedYear)
                                            ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleProductYearChange({
                                          target: {
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Product Year"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorProductYearBase}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputName"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Name
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={productNameOptions.map((item) => ({
                                        value: item.name,
                                        label: item.name,
                                        code: item.code,
                                        productMake: item.productMake,
                                        uim: item.uim,
                                        unitCost: item.unitCost,
                                        productMakeId: item.productMakeId,
                                      }))}
                                      value={
                                        productName
                                          ? productNameOptions
                                            .map((item) => ({
                                              value: item.name,
                                              label: item.name,
                                              code: item.code,
                                              productMake: item.productMake,
                                              uim: item.uim,
                                              unitCost: item.unitCost,
                                              productMakeId: item.productMakeId,
                                            }))
                                            .find((option) => option.value === productName) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleProductName({
                                          target: {
                                            value: selectedOption?.value || "",
                                            selectedIndex: 0,
                                            options: [
                                              {
                                                getAttribute: (attr) => {
                                                  switch (attr) {
                                                    case "code":
                                                      return selectedOption?.code || "";
                                                    case "data-productMake":
                                                      return selectedOption?.productMake || "";
                                                    case "data-uim":
                                                      return selectedOption?.uim || "";
                                                    case "data-unitCost":
                                                      return selectedOption?.unitCost || "";
                                                    case "data-productbrandId":
                                                      return selectedOption?.productMakeId || "";
                                                    default:
                                                      return "";
                                                  }
                                                },
                                              },
                                            ],
                                          },
                                        })
                                      }
                                      placeholder="Select Product"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorProductName}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputText"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Make(Brand)
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input type="text" className="form-control p-2" value={productMake} placeholder="Product Make" />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorProductMake}
                                  </span>
                                </div>
                                <div className="col-md-6 mt-1">
                                  <label
                                    for="fileInput"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Stock In Quantity
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2"
                                      placeholder="Stock-In-Quantity"
                                      value={stockInQuantity}
                                      onChange={handleStockInQuantity}
                                      onKeyDown={(e) => {
                                        if (e.key === "." || e.key === "," || e.key === "e") {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorStockInQuantity}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputText"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Unit Size(UIM)
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input type="text" className="form-control p-2" value={unitSize_uim} placeholder="UIM" />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorUnitSize}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputNumber"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Unit Price
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2 "
                                      placeholder="Unit Price"
                                      value={unitPrice} onChange={handleUnitPrice}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorUnitPrice}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputText"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Store Location
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100 mt-1">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={storeLocationOptions.map((item) => ({
                                        value: item.name,
                                        label: item.name,
                                        code: item.code,
                                      }))}
                                      value={
                                        productStoreLocation
                                          ? storeLocationOptions
                                            .map((item) => ({
                                              value: item.name,
                                              label: item.name,
                                              code: item.code,
                                            }))
                                            .find(
                                              (option) =>
                                                option.value === String(productStoreLocation)
                                            ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleProductStoreLocation({
                                          target: {
                                            value: selectedOption?.value || "",
                                            selectedIndex: 0,
                                            options: [
                                              {
                                                getAttribute: (attr) => {
                                                  switch (attr) {
                                                    case "code":
                                                      return selectedOption?.code || "";
                                                    default:
                                                      return "";
                                                  }
                                                },
                                              },
                                            ],
                                          },
                                        })
                                      }
                                      placeholder="Select Product Store Location"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorProductStoreLocation}
                                  </span>
                                </div>

                                <div className="col-md-6  mt-1">
                                  <label
                                    for="InputNumber"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product PO Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="PO Number"
                                      value={productPONumber}
                                      onChange={handleProductPoNumber}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorProductPONumber}
                                  </span>
                                </div>

                                <div className="col-md-6  mt-1">
                                  <label className="form-label text-sm font-weight-600 mb-0">
                                    Please Select Invoice/Dc No
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div>
                                    <label className="mt-2">
                                      <input
                                        type="radio"
                                        name="productInvoiceOrDCno"
                                        value={productInvoiceOrDCno}
                                        checked={
                                          productInvoiceOrDCno === "invoice"
                                        } // Check if "Yes" is selected
                                        onChange={() =>
                                          handleRadioChange("invoice")
                                        }
                                      />{" "}
                                      Invoice No
                                    </label>{" "}
                                    &nbsp;
                                    <label>
                                      <input
                                        type="radio"
                                        checked={productInvoiceOrDCno === "dc"}
                                        name="productInvoiceOrDCno"
                                        value={productInvoiceOrDCno}
                                        onChange={() => handleRadioChange("dc")}
                                      />{" "}
                                      DC
                                    </label>{" "}
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorProductInvoiceNumber}
                                  </span>
                                </div>

                                <div className="col-md-6 mt-1">
                                  <label
                                    for="fileInput"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    {productInvoiceOrDCno === "invoice"
                                      ? "Product Invoice Number"
                                      : "DC Number"}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder={
                                        productInvoiceOrDCno === "invoice"
                                          ? "Enter Invoice Number"
                                          : "Enter DC Number"
                                      }
                                      onChange={handleProductInvoiceNumber}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6 mt-1">
                                  <label
                                    htmlFor="vendorName"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Vendor Name
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={getMasterVendor.map((option) => ({
                                        value: option.name,
                                        label: option.name,
                                        code: option.code,
                                      }))}
                                      value={
                                        vendorName
                                          ? getMasterVendor
                                            .map((option) => ({
                                              value: option.name,
                                              label: option.name,
                                              code: option.code,
                                            }))
                                            .find(
                                              (option) =>
                                                option.value === String(vendorName)
                                            ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleVendor({
                                          target: {
                                            value: selectedOption?.value || "",
                                            selectedIndex: 0,
                                            options: [
                                              {
                                                getAttribute: (attr) => {
                                                  switch (attr) {
                                                    case "code":
                                                      return selectedOption?.code || "";
                                                    default:
                                                      return "";
                                                  }
                                                },
                                              },
                                            ],
                                          },
                                        })
                                      }
                                      placeholder="Select Vendor"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorVendorName}
                                  </span>
                                </div>


                                <div className="col-md-6 mt-1 ">
                                  <label
                                    for="InputText"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Batch Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="Enter Batch Number"
                                      value={batchNumber}
                                      onChange={handleBatchNumber}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorBatchNumber}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputNumber"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Manufacture Date
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <DatePicker
                                      selected={
                                        productManufactureDate
                                          ? new Date(productManufactureDate)
                                          : null
                                      }
                                      onChange={(date) =>
                                        handleProductManufactureDate({
                                          target: {
                                            value: date
                                              ? moment(date).format("YYYY-MM-DD")
                                              : "",
                                          },
                                        })
                                      }
                                      dateFormat="dd-MMM-yyyy"
                                      placeholderText="Select Date"
                                      maxDate={new Date()}
                                      customInput={<CustomDatePickerInput />}
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorProductManufactureDate}
                                  </span>
                                </div>


                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    htmlFor="InputNumber"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Product Expiry Date
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <DatePicker
                                      selected={
                                        productExpiryDate
                                          ? new Date(productExpiryDate)
                                          : null
                                      }
                                      onChange={(date) =>
                                        handleProductExpiryDate({
                                          target: {
                                            value: date
                                              ? moment(date).format("YYYY-MM-DD")
                                              : "",
                                          },
                                        })
                                      }
                                      dateFormat="dd-MMM-yyyy"
                                      placeholderText="Select Date"
                                      customInput={<CustomDatePickerInput />}
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorProductExpiryDate}
                                  </span>
                                </div>



                                <div className="col-md-6 mt-1">
                                  <label
                                    htmlFor="InputNumber"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Submitted Date
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <DatePicker
                                      selected={
                                        submittedDate
                                          ? new Date(submittedDate)
                                          : null
                                      }
                                      onChange={(date) =>
                                        handleSubmittedDate({
                                          target: {
                                            value: date
                                              ? moment(date).format("YYYY-MM-DD")
                                              : "",
                                          },
                                        })
                                      }
                                      dateFormat="dd-MMM-yyyy"
                                      placeholderText="Submitted Date"
                                      customInput={<CustomDatePickerInput />}
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorSubmittedDate}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    for="InputNumber"
                                    className="form-label text-sm font-weight-600 mb-0"
                                  >
                                    Remarks
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <textarea
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Type here"
                                      value={remarks}
                                      onChange={handleRemarks}
                                      style={{ height: "100px" }}
                                    />
                                  </div>
                                  {/* <span style={{ color: 'red' }}>{errorRemarks}</span>                                  
                                   */}
                                </div>

                                <div className="col-md-6 ">
                                  <label className="form-label text-sm font-weight-600 mb-0">
                                    Upload Invoice / DC
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                    <input
                                      type="file"
                                      onChange={handleFileChange}
                                      accept="image/*"
                                      className="mt-2"
                                    />
                                    <img
                                      src={UploadFile}
                                      style={{ height: 70 }}
                                    />
                                  </label>
                                  {imageUpload && (
                                    <div>
                                      <p>Selected Image:</p>
                                      <img
                                        src={imageUploadShow}
                                        alt="Selected"
                                        style={{
                                          maxHeight: "80px",
                                          maxWidth: "50%",
                                          border: "1px solid black",
                                        }} // You can adjust the height and width values
                                      />
                                    </div>
                                  )}
                                  {/* <span style={{ color: "red" }}>
                                    {errorImageUpload}
                                  </span> */}
                                </div>

                              </div>
                              &nbsp;
                              <div className="row">
                                {isSubmitted ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Record submitted.
                                  </p>
                                ) : null}
                                {isUpdated ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Updated Successfully.
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center col-md-12">
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() => handleSubmit({})}
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  onClick={handleCancel_new}
                                  className="btnn btn btn-danger"
                                >
                                  Cancel
                                </Button>
                              </div>
                              {recordExists && <p>{recordExists}</p>}
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Stock In Ward
                                </span>
                              </Modal.Title>

                              {/* <Button variant="link" className="close btn btn-danger btn-sm close_btn" onClick={handleCancel}>
                                X
                              </Button> */}
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showWarningPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Stock In Ward
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Stock In Ward
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {loading && (
                  <div>
                    <p>Fetching data. Please wait...</p>

                    <Loader
                      height="80"
                      width="80"
                      radius="9"
                      color="#4A7729"
                      ariaLabel="loading"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default StockInWard;
